export default "__VITE_ASSET__Pg3MxFNA__"